export default {
  freeDelivery: {
    id: 'product_page_refurb_process_free_delivery',
    defaultMessage: 'Free delivery by May-19',
  },
  thirtyDaysReturns: {
    id: 'product_page_refurb_process_thirty_days_returns',
    defaultMessage: '30-day free returns',
  },
  free1YearWarranty: {
    id: 'product_page_refurb_process_free_1_year_warranty',
    defaultMessage: 'Free 1-year warranty',
  },
  freeShipping: {
    id: 'product_page_shipping_with_date',
    defaultMessage: 'Get it between {dates, html} free standard shipping',
  },
  freeShippingDates: {
    id: 'product_page_shipping_dates',
    defaultMessage: '{earliest} and {latest}',
  },
  freeShippingWithoutDates: {
    id: 'product_page_shipping_without_date',
    defaultMessage: 'Free delivery',
  },
}
